import LoadConfiguration from './LoadConfiguration'
import SaveConfigurationSaga from './SaveImporter'
import { RemoveImporterSaga, RemoveExtensionSaga } from './RemoveImporterSaga'
import TempoCloud from './TempoCloud'

export default [LoadConfiguration, SaveConfigurationSaga, RemoveImporterSaga, RemoveExtensionSaga, ...TempoCloud]
